// extracted by mini-css-extract-plugin
export default {"container":"styles_container__InK71","renderSection":"styles_renderSection__zxWv-"};